var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.496,
    height: 96.771,
    viewBox: "0 0 119.496 96.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(-1768.066 -254.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09",
    transform: "translate(154 -8.641)",
    fill: "none",
    stroke: "#6f0298",
    strokeWidth: 2,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09",
    transform: "translate(164 15.359)",
    fill: "none",
    stroke: "#eba31a",
    strokeWidth: 2,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09",
    transform: "translate(168 39.359)",
    fill: "none",
    stroke: "#0797e6",
    strokeWidth: 2,
    opacity: 0.55
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterShape);
export default __webpack_public_path__ + "static/media/footer-shape.7b9192150fb78143e4165d6f1ec34450.svg";
export { ForwardRef as ReactComponent };